import { useState } from "react";
import {
  Container,
  ToggleWrapper,
  ToggleOption,
  DiscountBadge,
} from "../styles";
import { useTranslation } from "react-i18next";
import useBreakPoinst from "@hooks/useBreakPoinst";

interface TogglePeriodProps {
  selectedPeriod?: "Yearly" | "Monthly";
  onChange: (value: "Yearly" | "Monthly") => void;
}
const TogglePeriod = ({ selectedPeriod, onChange }: TogglePeriodProps) => {
  const [activeTap, setActiveTap] = useState<"Yearly" | "Monthly">(
    selectedPeriod || "Yearly"
  );
  const { t } = useTranslation();
  const { isPhone } = useBreakPoinst();

  function handleChange(value: "Yearly" | "Monthly") {
    setActiveTap(value);
    onChange(value);
  }

  return (
    <Container>
      <ToggleWrapper $isPhone={isPhone}>
        <ToggleOption
          $isActive={activeTap === "Yearly"}
          onClick={() => handleChange("Yearly")}
        >
          {t("chooseSubscription.yearly")}
          {activeTap === "Yearly" && (
            <DiscountBadge>{t("chooseSubscription.discount")}</DiscountBadge>
          )}
        </ToggleOption>
        <ToggleOption
          $isActive={activeTap === "Monthly"}
          onClick={() => handleChange("Monthly")}
        >
          {t("chooseSubscription.monthly")}
        </ToggleOption>
      </ToggleWrapper>
    </Container>
  );
};

export default TogglePeriod;
